import request from '@/utils/axios'

export function getLogin(params) {
  return request({
    baseURL: '/as',
    url: '/edu_web/login',
    method: 'post',
    data: params
  })
}
export function getCheckFunctionDeleteMobile(params) {
  return request({
    url: '/edu_home/auth/check_function_delete_mobile',
    method: 'get',
    params
  })
}

export const getUserInfo = () => {
  return request({
    url: '/edu_home/auth/get_user_info',
    method: 'get',
  })
}

export const getObs = () => {
  return request({
    url: '/edu_basic/auth/get_huaweiyun_obs_list',
    method: 'get',
  })
}

export function initQrcode(params) {
  return request({
    baseURL: '/as',
    url: '/edu_web/init_qrcode',
    method: 'get'
  })
}
export function getMenus(params) {
  return request({
    baseURL: '/as',
    url: '/edu_web/menus',
    method: 'get'
  })
}

export function validationOrg(params) {
  return request({
    url: '/edu_home/auth/get_default_organization_info',
    method: 'get'
  })
}
